import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function Statute() {
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname.split('/')[2];
        switch (path) {
            case 'cookies':
                if (!cookiesRef.current) return;
                window.scrollTo({
                    top: cookiesRef.current?.getBoundingClientRect().top + window.pageYOffset - 80,
                    behavior: 'smooth',
                });
                break;
            case 'privacy':
                if (!privacyPolicyRef.current) return;
                window.scrollTo({
                    top:
                        privacyPolicyRef.current?.getBoundingClientRect().top +
                        window.pageYOffset -
                        80,
                    behavior: 'smooth',
                });

                break;
        }
    }, [location]);

    const cookiesRef = useRef<HTMLLIElement>(null);
    const privacyPolicyRef = useRef<HTMLDivElement>(null);
    return (
        <div className={'statute margin py-8'}>
            <div className={'ml-auto mr-auto max-w-[1000px]'}>
                <h1 className={'mb-1 text-2xl text-slate-800'}>
                    Regulamin korzystania z systemu "Sprawne Miasto"
                </h1>
                <hr />

                <div className={'mt-7'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700 '}>
                        § 1<br />
                        Postanowienia ogólne
                    </h2>

                    <ol>
                        <li>
                            Regulamin określa warunki korzystania oraz funkcjonowania serwisu
                            internetowego o nazwie{' '}
                            <a href={'https://www.sprawnemiasto.pl/'} className={'link'}>
                                https://www.sprawnemiasto.pl/
                            </a>{' '}
                            oraz aplikację mobilną o nazwie "Sprawne Miasto".
                        </li>

                        <li>
                            Regulamin normuje obowiązki i zakres odpowiedzialności Administratora,
                            jako podmiotu zarządzającego{' '}
                            <a href={'https://www.sprawnemiasto.pl/'} className={'link'}>
                                https://www.sprawnemiasto.pl/
                            </a>{' '}
                            oraz prawa i obowiązki zarejestrowanych Użytkowników tego Portalu.
                        </li>

                        <li>
                            Warunkiem koniecznym do korzystania z platformy{' '}
                            <a href={'https://www.sprawnemiasto.pl/'} className={'link'}>
                                https://www.sprawnemiasto.pl/
                            </a>{' '}
                            oraz aplikacji o nazwie "Sprawne Miasto" jest akceptacja postanowień
                            niniejszego Regulaminu.
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 2<br />
                        Definicje
                    </h2>

                    <ol>
                        <li>
                            <b>Aplikacja</b> - oprogramowanie o nazwie "Sprawne Miasto", która służy
                            do zgłaszania usterek infrastruktury publicznej w wybranej gminie na
                            urządzeniach mobilnych.
                        </li>

                        <li>
                            <b>Regulamin</b> - niniejszy regulamin.
                        </li>

                        <li>
                            <b>Serwis</b> - serwis internetowy prowadzony pod adresem{' '}
                            <a href={'https://www.sprawnemiasto.pl/'} className={'link'}>
                                https://www.sprawnemiasto.pl/
                            </a>
                            , w którym usługodawca świadczy usługi drogą elektroniczną.
                        </li>
                        <li>
                            <b>System</b> - platforma komunikacyjna o nazwie "Sprawne Miasto"
                            umożliwiająca korzystanie z niej za pośrednictwem platformy lub
                            aplikacji mobilnej.
                        </li>
                        <li>
                            <b>Odbiorca</b> - każda współpracują gmina z systemem "Sprawne Miasto".
                        </li>
                        <li>
                            <b>Umowa</b> - umowa o świadczenie usług drogą elektroniczną zawarta
                            między Usługodawcą a Użytkownikiem w związku z korzystaniem z Aplikacji
                            lub Serwisu, zgodnie z postanowieniami niniejszego Regulaminu.
                        </li>
                        <li>
                            <b>Użytkownik</b> - każda osoba fizyczna, która korzysta z aplikacji lub
                            serwisu o nazwie "Sprawne Miasto".
                        </li>
                        <li>
                            <b>Zarejestrowany użytkownik</b> - użytkownik, który założył konto w
                            Systemie.
                        </li>
                        <li>
                            <b>Niezarejestrowany użytkownik</b> - użytkownik, który nie założył
                            konta w Systemie.
                        </li>
                        <li>
                            <b>Zgłoszenie</b> - informacja dotyczące problemu w przestrzeni
                            publicznej współpracującej gminy wprowadzone do systemu przez
                            Użytkownika.
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 3<br />
                        Wymagania techniczne
                    </h2>

                    <ol>
                        <li>
                            W celu korzystania z serwisu Użytkownik powinien zapewnić następujące
                            wymagania techniczne:
                            <ul>
                                <li>
                                    Dostęp do aktywnego połączenia internetowego, co najmniej 50
                                    KB/s
                                </li>
                                <li>Posiadanie wyszukiwarki internetowej na swoim urządzeniu.</li>
                            </ul>
                        </li>

                        <li>
                            W celu korzystania z Aplikacji Mobilnej Użytkownik powinien zapewnić
                            następujące wymagania techniczne:
                            <ul>
                                <li>Dostęp do aktywnego połączenia internetowego</li>
                                <li>System operacyjny nie starszy niż Android 4.1.</li>
                            </ul>
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 4<br />
                        Rejestracja i zarządzanie kontem
                    </h2>

                    <ol>
                        <li>
                            W celu rejestracji użytkownik musi podać następujące dane: nazwa
                            użytkownika, e-mail, hasło:
                            <ul>
                                <li>nazwa użytkownika musi zawierać od 3 do 32 znaków;</li>
                                <li>
                                    hasło musi zawierać od 8 do 32 znaków oraz co najmniej jedną
                                    małą literę, oraz przynajmniej jedną wielką literę. Hasło
                                    powinno także zawierać jeden znak specjalny tj.
                                    !@#$%^&*()[]|:\";{'<>'}?,./.
                                </li>
                            </ul>
                        </li>

                        <li>
                            W celu logowania się do systemu użytkownik powinien zalogować się na
                            konto utworzone podczas rejestracji w systemie Sprawne Miasto.
                        </li>

                        <li>
                            Użytkownik ma prawo w każdej chwili zrezygnować z posiadania konta na
                            platformie Sprawne Miasto i usunąć swoje dane podane przy rejestracji
                            konta.
                        </li>

                        <li>
                            Użytkownik może w każdej chwili zmienić swoje dane, które podał przy
                            rejestracji konta.
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 5<br />
                        Zgłaszania incydentów infrastruktury publicznej
                    </h2>

                    <ol>
                        <li>Tytuł zgłoszenia musi zawierać od 5 do 256 znaków.</li>

                        <li>Opis zgłoszenia musi zawierać od 10 do 512 znaków.</li>

                        <li>Użytkownik powinien wybrać poprawną kategorię zgłoszenia.</li>

                        <li>
                            Zarejestrowany Użytkownik może załączyć zdjęcia do swojego zgłoszenia.
                            Zdjęcia muszą być w rozdzielczości 144p. Dopuszczalne są zdjęcia do
                            rozdzielczości 4K.
                        </li>

                        <li>Zarejestrowany Użytkownik może załączyć maksymalnie do ośmiu zdjęć.</li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 6<br />
                        Korzystanie z systemu
                    </h2>

                    <ol>
                        <li>
                            Z Systemu mogą korzystać użytkownicy zarejestrowani oraz użytkownicy
                            niezarejestrowani.
                        </li>

                        <li>
                            System służy do komunikacji między mieszkańcem gminy, a instytucjami
                            samorządowymi.
                        </li>

                        <li>
                            System służy tylko i wyłącznie do zgłaszania incydentów, które nie
                            zagrażają życiu i zdrowi innych osób.
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 7<br />
                        Odpowiedzialność użytkownika
                    </h2>

                    <ol>
                        <li>
                            Użytkownik przyjmuje do wiadomości, że Aplikacja i Serwis wykorzystują
                            połączenie internetowe do wielu funkcji a za dostęp do sieci Internet
                            lub transmisji danych może być pobierana opłata zgodnie z cennikiem
                            dostawcy.
                        </li>

                        <li>
                            Użytkownicy odpowiedzialni są za wszelkie naruszenia obowiązującego
                            prawa oraz postanowień niniejszego Regulaminu podczas korzystania z
                            Serwisu.
                        </li>

                        <li>
                            Zakazane jest wprowadzanie przez Użytkowników jakiejkolwiek treści o
                            charakterze bezprawnym, w szczególności:
                            <ul>
                                <li>
                                    naruszających w jakikolwiek sposób obowiązujące prawo i dobre
                                    obyczaje;
                                </li>
                                <li>wzywających do nienawiści rasowej, etnicznej, wyznaniowej;</li>
                                <li>pochwalających faszyzm, nazizm, komunizm;</li>
                                <li>propagujących przemoc, obrażających uczucia religijne;</li>
                                <li>uznawanych za spam.</li>
                            </ul>
                        </li>

                        <li>
                            Zakazane jest wprowadzanie przez Użytkowników danych niezgodnych z
                            rzeczywistością, w szczególności:
                            <ul>
                                <li>nieprawdziwych danych profilowych;</li>
                                <li>nieprawdziwych Zgłoszeń;</li>
                                <li>nieprawdziwych informacji w treści Zgłoszeń.</li>
                            </ul>
                        </li>

                        <li>
                            Użytkownik ponosi pełną odpowiedzialność za złamanie obowiązującego
                            prawa bądź szkodę wywołaną jego działaniami w Serwisie, w szczególności
                            za podanie niezgodnych z prawem informacji lub nieprawdziwych danych
                            osobowych, naruszenie dóbr osobistych lub praw autorskich oraz praw
                            pokrewnych, a także ujawnienie tajemnicy służbowej lub innej informacji
                            poufnej.
                        </li>
                        <li>
                            Administrator zastrzega sobie prawo do odmowy świadczenia usług wobec
                            Użytkownika, w przypadku naruszenia lub uzasadnionego podejrzenia
                            naruszenia przez Użytkownika obowiązującego prawa lub postanowień
                            niniejszego Regulaminu.
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 8<br />
                        Odpowiedzialność Administratora
                    </h2>

                    <ol>
                        <li>
                            Administrator jest podmiotem świadczącym usługi drogą elektroniczną w
                            postaci Serwisu - platformy służącej rozwijaniu idei społeczeństwa
                            obywatelskiego. W szczególności Serwis wspiera aktywności obywatelskie
                            dotyczące przestrzeni publicznej.
                        </li>
                        <li>
                            Administrator nie ponosi żadnych odpowiedzialności za nieprzestrzeganie
                            prawa przez użytkowników systemu.
                        </li>
                        <li>
                            Administrator może udostępnić dane użytkownika organom ścigania w celu
                            postawienia zarzutów użytkownikowi, który dopuścił się złamania
                            obowiązującego prawa.
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 9<br />
                        Ochrona danych osobowych
                    </h2>
                    <ol>
                        <li>Administratorem danych osobowych jest Zespół Sprawne Miasto.</li>
                        <li>
                            Dane kontaktowe do Administratora:
                            <ul>
                                <li>
                                    adres e-mail:{' '}
                                    <a href={'mailto:rodo@sprawnemiasto.pl'} className={'link'}>
                                        rodo@sprawnemiasto.pl
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            W serwisie dane osobowe są przetwarzane w zakresie podanym przez
                            użytkownika podczas rejestracji lub zgłaszania usterki jako
                            niezarejestrowany użytkownik.
                        </li>
                        <li>
                            Dane podane podczas:
                            <ul>
                                <li>
                                    rejestracji - służą tylko i wyłącznie informowaniu użytkownika o
                                    zgłoszeniach dokonanych przez niego;
                                </li>
                                <li>
                                    zgłaszania usterki poprzez formularz jako niezarejestrowany
                                    użytkownik - służą tylko i wyłącznie informowaniu użytkownika o
                                    zgłoszeniu dokonanym przez niego;
                                </li>
                            </ul>
                        </li>
                        <li>
                            Administrator nie przechowuje kopii danych użytkownika, wszystkie
                            dokonane przez użytkownika zmiany danych, a także ich usunięcie, są
                            nieodwracalne i nie będzie można ich przywrócić.
                        </li>
                        <li>
                            Użytkownikowi przysługuje prawo do:
                            <ul>
                                <li>dostępu do swoich danych oraz otrzymania kopii;</li>
                                <li>sprostowania danych osobowych;</li>
                                <li>usunięcia danych;</li>
                                <li>ograniczenia przetwarzania danych;</li>
                                <li>
                                    wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'} ref={privacyPolicyRef}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 10
                        <br />
                        Polityka prywatności
                    </h2>
                    <ol>
                        <li>Administrator szanuje prywatność użytkowników Serwisu.</li>
                        <li>
                            Podczas korzystania z systemu Administrator gromadzi następujące dane:
                            <ul>
                                <li>
                                    zapytania HTTP (w tym adresy IP, z których wysyłane są te
                                    zapytania, zasoby przeglądane przez użytkownika, nazwa klienta
                                    przeglądarki, itp. Więcej informacji można uzyskać pod adresem:{' '}
                                    <a href={'https://httpwg.org/specs/'} className={'link'}>
                                        https://httpwg.org/specs/
                                    </a>{' '}
                                    ).
                                </li>
                            </ul>
                        </li>
                        <li>
                            Podczas rejestracji w systemie Administrator gromadzi następujące dane:
                            <ul>
                                <li>nazwa użytkownika;</li>
                                <li>hasło;</li>
                                <li>adres e-mail.</li>
                            </ul>
                        </li>
                        <li>
                            Podczas zgłaszania usterki poprzez formularz zgłoszenia Administrator
                            gromadzi następujące dane:
                            <ul>
                                <li>tytuł zgłoszenia;</li>
                                <li>opis zgłoszenia;</li>
                                <li>kategoria zgłoszenia;</li>
                                <li>
                                    w przypadku Użytkownika Niezarejestrowanego:
                                    <ul>
                                        <li>adres e-mail;</li>
                                    </ul>
                                </li>
                                <li>
                                    w przypadku Użytkownika Zarejestrowanego:
                                    <ul>
                                        <li>zdjęcia podane opcjonalnie.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li ref={cookiesRef}>
                            Serwis korzysta z plików cookies w celu świadczenia usług na najwyższym
                            poziomie.
                        </li>
                        <li>
                            Serwis korzysta z:
                            <ul>
                                <li>
                                    cookies google-analytics.com - służą one do prowadzenia
                                    statystyk dla Serwisu "Sprawne Miasto". (Więcej informacji jest
                                    dostępnych pod adresem:{' '}
                                    <a
                                        className={'link'}
                                        href={
                                            'https://marketingplatform.google.com/about/analytics/terms/pl/'
                                        }>
                                        https://marketingplatform.google.com/about/analytics/terms/pl/
                                    </a>
                                    ,{' '}
                                    <a
                                        className={'link'}
                                        href={'https://policies.google.com/privacy/'}>
                                        https://policies.google.com/privacy/
                                    </a>{' '}
                                    );
                                </li>
                                <li>
                                    sesyjnych plików cookies - są to tymczasowe informacje
                                    przechowywane w pamięci przeglądarki do momentu zakończenia
                                    sesji, czyli jej zamknięcia;
                                </li>
                                <li>
                                    stałych plików cookies - są to pliki przechowujące informacje
                                    dotyczące ustawień Serwisu, zgłoszonych usterek, sesji
                                    logowania.
                                </li>

                                <li>
                                    Użytkownik w każdym momencie ma możliwość wyłączenia plików
                                    cookies w swojej przeglądarce.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 11
                        <br />
                        Zgłaszanie użytkowników serwisu, błędów, sugestii
                    </h2>

                    <ol>
                        <li>
                            Odbiorca może zgłosić użytkownika za nieprzestrzeganie niniejszego
                            regulaminu.
                        </li>
                        <li>
                            Twórcy serwisu Sprawne Miasto zastrzegają sobie możliwość blokady konta
                            użytkownika bez podania przyczyny.
                        </li>
                        <li>
                            Użytkownik bądź gmina współpracują może zgłosić swoją sugestię do
                            twórców oprogramowania o nazwie Sprawne Miasto przez adres e-mailowy:{' '}
                            <a className={'link'} href={'mailto:contact@sprawnemiasto.pl'}>
                                contact@sprawnemiasto.pl
                            </a>
                            .
                        </li>
                    </ol>
                </div>

                <div className={'mt-5'}>
                    <h2 className={'mb-2 text-center text-lg font-medium text-slate-700'}>
                        § 12
                        <br />
                        Zmiana postanowień regulaminu korzystania z serwisu "Sprawne Miasto"
                    </h2>
                    <ol>
                        <li>
                            Twórcy zastrzegają sobie prawo do ostatecznej interpretacji niniejszego
                            regulaminu.
                        </li>
                        <li>
                            Twórcy w każdej chwili mogą zmienić regulamin, o której użytkownicy
                            dowiedzą się przynajmniej 7 dni przed wejściem w życie zmian.
                        </li>
                        <li>
                            Twórcy udostępniają publiczny adres e-mailowy{' '}
                            <a className={'link'} href={'mailto:contact@sprawnemiasto.pl'}>
                                contact@sprawnemiasto.pl
                            </a>{' '}
                            w celu ewentualnego kontaktu dla użytkowników systemu.
                        </li>
                        <li>
                            Twórcy zastrzegają sobie prawo do kopiowania przez innych oprogramowania
                            o nazwie Sprawne Miasto.
                        </li>
                        <li>
                            Użytkownicy mogą robić zrzuty ekranu strony{' '}
                            <a className={'link'} href={'https://www.sprawnemiasto.pl/'}>
                                https://www.sprawnemiasto.pl/
                            </a>{' '}
                            oraz aplikacji mobilnej "Sprawne Miasto".
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    );
}
